// extracted by mini-css-extract-plugin
export default {"container":"Ep-z","bubbleNav":"Fp-z","graphic":"Gp-z","contact":"Hp-z"};